






















































import { Vue, Prop, Component, Emit } from 'vue-property-decorator';
import Button from '@/components/utils/Button.vue';

@Component({
  components: {
    Button,
  },
})
export default class Popup extends Vue {
  @Prop({ type: Object, required: true })
  readonly details!: any;

  get compQueue(): string {
    return `Ligne ${this.details.queueName}`;
  }

  get compBranch(): string {
    return `Antenne : ${this.details.branchName}`;
  }

  get compManager(): string {
    return `Gestionnaire : ${this.details.queueManager}`;
  }

  get compPhone(): string {
    return `Tel : ${this.details.phone}`;
  }

  get compEmail(): string {
    return `Mail : ${this.details.email}`;
  }

  get compRequestDate(): string {
    const currentDate = new Date(this.details.requestDate);
    return `Demande effectuée le : ${currentDate.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })}`;
  }

  get compAddress(): string {
    return `${this.details.schoolAddress}, ${this.details.schoolZip} ${this.details.schoolCity}`;
  }

  get compIcons(): Array<any> {
    switch (this.details.status) {
      case 'validated':
        return [
          { icon: require('@/assets/icons/badgeReferencedLine.svg'), class: '' },
          { icon: require('@/assets/icons/badgeValidatedLine.svg'), class: 'smaller' },
        ];
      case 'waiting':
        return [{ icon: require('@/assets/icons/badgeWaitingLine.svg'), class: 'smaller2' }];
      case 'ongoing':
        return [{ icon: require('@/assets/icons/badgeOnGoingLine.svg'), class: 'smaller' }];
      case 'denied':
        return [{ icon: require('@/assets/icons/badgeRefusedLine.svg'), class: 'smaller' }];
      default:
        return [];
    }
  }

  async changeStatus(status: string): Promise<any> {
    await this.$store.dispatch('form/a_put_updateStatus', {
      params: {
        lineId: this.details.id,
        status,
      },
    });
  }

  @Emit('closePopup')
  closePopup(): void {}
}
